import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <IndexSection />
        <RankingSection />
        <CardsSection />
        <CarouselSection />
        <TopicsSection />
        <FeaturesSection />
        <FaqSection />
        <AppSection />
        <ContactSection />
        <MediaSection />
        <CommentsSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}